import { Autocomplete, TextField, Box, Chip, Stack } from "@mui/material"
import { useState, useEffect } from "react"
import API from "../../services/API";
import { txt } from "../../services/translation";

export default function Tags({label, value, onChange, onAdd, onDelete, required, types, single, sx}){

    const arrayValue = single ? (value ? [value] : []) : value;

    const [tags, setTags] = useState([]);

    useEffect(() => {

        API.get('/tags')
            .then(r => {
                let items = Array.isArray(r.data) ? r.data : [];
                if(types && types.length > 0){
                    items = items.filter(i => types.includes(i?.type?.id))
                }
                items.sort((a,b) => (a.type?.title + a.title) > (b.type?.title + b.title) ? 1 : -1)
                return setTags(items);
            })
            .catch(e => console.log(e))

    }, [types])

    const handleChange = tv => {
        let tag = tags.find(t => tagTitle(t) === tv);
        if(!tag) return false;

        let copy = single ? [] : [...arrayValue];
        copy = copy.filter(t => t.id !== tag.id);
        copy.unshift(tag);

        return onAdd ? 
            onAdd(tag, value) : 
            onChange(single ? copy[0] : copy);
    }

    const handleDelete = tagId => {
        let copy = [...arrayValue];
        copy = copy.filter(t => t.id !== tagId);
        return onDelete ? 
            onDelete(tagId, value) : 
            onChange(single ? copy[0] : copy);
    }

    const tagTitle = t => (!types || types?.length > 0) ? (t.type.title + ' : ' + t.title) : t.title;


    return <Stack direction='column' sx={sx}>

        <Autocomplete
            options={(tags || []).map(t => tagTitle(t))}
            renderInput={params => <TextField 
                {...params}
                label={label || 'Mos clés'}
                size='small'
            />}
            value={null}
            onChange={(e, v) => handleChange(v)}
            blurOnSelect
            required={arrayValue.length > 0 ? false : required}
            sx={{mb: 0.5}}
        />

        <Box>
            {arrayValue.map(t => 
                <Tag 
                    key={t.id} 
                    tag={t}
                    onDelete={() => handleDelete(t.id)}
                />    
            )}
        </Box>

    </Stack>
}




export function Tag({tag, onDelete, sx}){

    return <Chip 
        key={tag.id} 
        label={tag.type?.id === 'category' ? txt(tag.code + 'Hashtag') : tag.hashtag} 
        onDelete={onDelete} 
        sx={sx ? sx : {mt: 0.5}}
        variant='outlined'
        style={{
            borderColor: 'transparent', 
            color: tag.color,
            backgroundColor: 'transparent'
        }}
    />   
}